import React from "react";
import "./services.css";
import AutoTyping, { BlinkCursor } from "react-auto-typing";
import erpIcon from "../../assets/erp-integration.svg";
import biometricIcon from "../../assets/biometric-icon.svg";
import outsourcingIcon from "../../assets/project_based_oursourcing.svg";
import machineVisionIcon from "../../assets/machine-vision.svg";
import linePrintingIcon from "../../assets/product_line_printing.svg";
import cardPrintingIcon from "../../assets/id-card-icon.svg";
import { Link } from "react-router-dom";

const Services = () => {
  const scrollHeader = () => {
    window.scroll({ to: 0, behavior: "instant" });
  };
  return (
    <div className="services-wrapper">
      <div className="section-title">
        <h1 className="title">Our Services</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Services"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="services-details-container">
        <div className="services-details">
          <div className="row mt-12x gutter-y-6x">
            <div className="col-12 col-sm-6 col-md-3">
              <Link
                to="/service/custom-software-development"
                onClick={scrollHeader}
                style={{ textDecoration: "none" }}
              >
                <div className="card services-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                  <span className="card__icon-main card__icon orange">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 32 32"
                    >
                      <path
                        fill="#ff7a00"
                        d="M24 21c-.5 0-1-.2-1.4-.6l-3-3c-.4-.4-.6-.9-.6-1.4s.2-1 .6-1.4l3-3c.4-.4.9-.6 1.4-.6s1 .2 1.4.6l3 3c.4.4.6.9.6 1.4s-.2 1-.6 1.4l-3 3c-.4.4-.9.6-1.4.6m0-8l-3 3l3 3l3-3zm-8 0c-.5 0-1-.2-1.4-.6l-3-3C11.2 9 11 8.5 11 8s.2-1 .6-1.4l3-3c.4-.4.9-.6 1.4-.6s1 .2 1.4.6l3 3c.4.4.6.9.6 1.4s-.2 1-.6 1.4l-3 3c-.4.4-.9.6-1.4.6m0-8l-3 3l3 3l3-3zm0 24c-.5 0-1-.2-1.4-.6l-3-3c-.4-.4-.6-.9-.6-1.4s.2-1 .6-1.4l3-3c.4-.4.9-.6 1.4-.6s1 .2 1.4.6l3 3c.4.4.6.9.6 1.4s-.2 1-.6 1.4l-3 3c-.4.4-.9.6-1.4.6m0-8l-3 3l3 3l3-3zm-8 0c-.5 0-1-.2-1.4-.6l-3-3C3.2 17 3 16.5 3 16s.2-1 .6-1.4l3-3c.4-.4.9-.6 1.4-.6s1 .2 1.4.6l3 3c.4.4.6.9.6 1.4s-.2 1-.6 1.4l-3 3c-.4.4-.9.6-1.4.6m0-8l-3 3l3 3l3-3z"
                      />
                    </svg>
                  </span>
                  <p className="fs-lead card__title undefined">
                    Custom Software Development
                  </p>
                  <div className="card__body">
                    <p>
                      We design and develop bespoke software solutions that are
                      customized to fit your specific business needs, ensuring
                      efficiency and innovation.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-3">
              <Link
                to="/service/erp-integration"
                onClick={scrollHeader}
                style={{ textDecoration: "none" }}
              >
                <div className="card services-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                  <span className="card__icon-main card__icon purple">
                    <img src={erpIcon} alt="icon" width="48" height="48" />
                  </span>
                  <p className="fs-lead card__title undefined">
                    ERP Integration
                  </p>
                  <div className="card__body">
                    <p>
                      Integrate and optimize your enterprise resource planning
                      (ERP) systems for seamless business operations across
                      departments and workflows.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-3">
              <Link
                to="/service/biometric-and-facial-recognition"
                onClick={scrollHeader}
                style={{ textDecoration: "none" }}
              >
                <div className="card services-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                  <span className="card__icon-main card__icon green">
                    <img
                      src={biometricIcon}
                      alt="icon"
                      width="48"
                      height="48"
                    />
                  </span>
                  <p className="fs-lead card__title undefined">
                    Biometric & Facial Recognition
                  </p>
                  <div className="card__body">
                    <p>
                      Utilize cutting-edge biometric and facial recognition
                      technologies for secure, efficient, and reliable identity
                      verification processes.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-3">
              <Link
                to="/service/project-based-outsourcing"
                onClick={scrollHeader}
                style={{ textDecoration: "none" }}
              >
                <div className="card services-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                  <span className="card__icon-main card__icon blue">
                    <img
                      src={outsourcingIcon}
                      alt="icon"
                      width="48"
                      height="48"
                    />
                  </span>
                  <p className="fs-lead card__title undefined">
                    Project Based Outsourcing
                  </p>
                  <div className="card__body">
                    <p>
                      We provide flexible outsourcing services, allowing your
                      in-house team to collaborate with our developers on
                      projects, reducing workload and ensuring timely delivery
                      of custom software solutions.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-3">
              <Link
                to="/service/rfid-and-barcode-solutions"
                onClick={scrollHeader}
                style={{ textDecoration: "none" }}
              >
                <div className="card services-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                  <span className="card__icon-main card__icon orange">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#ff7a00"
                        d="M4 22h16a1 1 0 0 0 1-1v-8h-2v7H5V4h5V2H4a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1"
                      />
                      <circle cx="12" cy="11" r="1" fill="#ff7a00" />
                      <path
                        fill="#ff7a00"
                        d="M15 11h2a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3"
                      />
                      <path
                        fill="#ff7a00"
                        d="M19 11h2a9 9 0 0 0-9-9v2a7 7 0 0 1 7 7m-9.35 4.67a1 1 0 0 0-.14-.51a.76.76 0 0 0-.38-.31a2.3 2.3 0 0 0-.75-.09H7V18h.65v-1.35h.14a1.3 1.3 0 0 1 .33 0a.6.6 0 0 1 .19.14a5 5 0 0 1 .35.48l.47.7h.78l-.39-.63a3.6 3.6 0 0 0-.38-.53a1.3 1.3 0 0 0-.35-.27a1 1 0 0 0 .64-.3a.84.84 0 0 0 .22-.57m-.74.33a.4.4 0 0 1-.18.14a2.4 2.4 0 0 1-.59 0h-.49v-.82h1a.4.4 0 0 1 .25.13a.36.36 0 0 1 .09.26a.43.43 0 0 1-.08.29m2.01.62h1.36v-.54h-1.36v-.77h1.57v-.55h-2.22V18h.65zm2.09-1.86h.65V18h-.65zm3.09.06a2.5 2.5 0 0 0-.62-.06h-1.2V18h1.24a1.8 1.8 0 0 0 .57-.07a1.1 1.1 0 0 0 .46-.26a1.35 1.35 0 0 0 .35-.57a2 2 0 0 0 .1-.69a2.4 2.4 0 0 0-.11-.76a1.3 1.3 0 0 0-.31-.53a1.1 1.1 0 0 0-.48-.3m.16 2.18a.74.74 0 0 1-.17.31a.57.57 0 0 1-.27.13a1.8 1.8 0 0 1-.39 0h-.49v-2.13h.29a3 3 0 0 1 .54 0a.7.7 0 0 1 .3.15a.8.8 0 0 1 .19.32a2 2 0 0 1 .06.57a2.4 2.4 0 0 1-.06.65"
                      />
                    </svg>
                  </span>
                  <p className="fs-lead card__title undefined">
                    RFID & Bar Code Solutions
                  </p>
                  <div className="card__body">
                    <p>
                      Implement RFID and barcode systems to automate your asset
                      tracking, inventory management, and data collection
                      processes.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-3">
              <Link
                to="/service/machine-vision-solutions"
                onClick={scrollHeader}
                style={{ textDecoration: "none" }}
              >
                <div className="card services-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                  <span className="card__icon-main card__icon purple">
                    <img
                      src={machineVisionIcon}
                      alt="icon"
                      width="48"
                      height="48"
                    />
                  </span>
                  <p className="fs-lead card__title undefined">
                    Machine Vision Solutions
                  </p>
                  <div className="card__body">
                    <p>
                      Leverage AI-powered machine vision to automate visual
                      inspections, ensuring high standards of quality in
                      manufacturing and production lines.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-3">
              <Link
                to="/service/product-line-printing"
                onClick={scrollHeader}
                style={{ textDecoration: "none" }}
              >
                <div className="card services-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                  <span className="card__icon-main card__icon green">
                    <img
                      src={linePrintingIcon}
                      alt="icon"
                      width="48"
                      height="48"
                    />
                  </span>
                  <p className="fs-lead card__title undefined">
                    Product Line Printing
                  </p>
                  <div className="card__body">
                    <p>
                      Boost your production with advanced printing technologies,
                      delivering fast and precise printing on product lines and
                      packaging.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-3">
              <Link
                to="/service/identity-management-solution"
                onClick={scrollHeader}
                style={{ textDecoration: "none" }}
              >
                <div className="card services-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                  <span className="card__icon-main card__icon blue">
                    <img
                      src={cardPrintingIcon}
                      alt="icon"
                      width="48"
                      height="48"
                    />
                  </span>
                  <p className="fs-lead card__title undefined">
                    Identity Management Solution
                  </p>
                  <div className="card__body">
                    <p>
                      Soori Corporation provides integrated ID card printing
                      solutions that streamline the management of employee,
                      student, and industry-specific identification needs. Our
                      advanced systems ensure secure and efficient ID
                      management, featuring customizable designs, rapid
                      issuance, and seamless integration with existing systems,
                      all while maintaining high standards of professionalism
                      and security
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
